import { ActivatedRoute, Params } from "@angular/router";
import { OnInit } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { SessaoUtil } from "../../util/sessao-util";
import { UtilService } from "../../util/util.service";
import { Funcionalidade } from "../../util/enum/funcionalidade.enum";
import { Modo } from "../../util/enum/modo.enum";

export class SharedComponent {

    private funcionalidade: Funcionalidade;
    private modo: Modo;
    private fieldsDisabled : Array<string> = [];
    public disabledProperties : boolean = false;

    constructor(private activatedRoute: ActivatedRoute,
                private session: SessaoUtil) {
        this.funcionalidade = this.activatedRoute.snapshot.data['funcionalidade'];
        this.modo = this.activatedRoute.snapshot.data['modo'];
    }

    setModo(modo: Modo){
        if(modo != undefined && modo != null){
            this.modo = modo;
        }
    }

    getModo() {
        return this.modo;
    }

    getPodeConsultar(){
        return this.session.possuiPermissao(this.funcionalidade);
    }

    getPodeIncluir(){
        return this.session.possuiPermissaoTotal(this.funcionalidade);
    }

    getPodeAlterar(){
        return this.session.possuiPermissaoTotal(this.funcionalidade);
    }

    getPodeExcluir(){
        return this.session.possuiPermissaoTotal(this.funcionalidade);
    }

    getPodeSalvar(){
      if(Modo.INCLUSAO == this.getModo()){
            return this.getPodeIncluir();
        }else if(Modo.ALTERACAO == this.getModo()){
            return this.getPodeAlterar();
        }else{
            return false;
        }
    }

    isModoConsulta() {
        return Modo.CONSULTA == this.modo;
    }

    isUsuarioAcessoTotal(){
      return this.session != null && this.session.isUsuarioAcessoTotal();
    }

    isUsuarioAdministrador() {
      return this.session != null && this.session.isUsuarioAdministrador();
    }

    isUsuarioTemporario(){
      return this.session != null && this.session.login == 'suporteats' && this.session.suporteTemporario;
    }

    isModoInclusao() {
      return Modo.INCLUSAO == this.modo;
    }

    processaEdicaoCampos(form : FormGroup){
      if(Modo.CONSULTA == this.getModo() ){
          this.disabledProperties = true;
          for (let field in form.controls) {
            form.get(field).disable();
          }
        }else{
          this.disabledProperties = false;
          for (let field in form.controls) {
            form.get(field).enable();
          }
          this.processaFieldDisabled(form);
        }
    }

    processaFieldDisabled(form : FormGroup){
        if(!UtilService.empty(this.fieldsDisabled)){
            for (let fieldName of this.fieldsDisabled) {
                form.get(fieldName).disable();
            }
        }
    }

    disabledFields(form : FormGroup, fieldsDisabled: Array<string>){
        if(!UtilService.empty(fieldsDisabled)){
            for (let fieldName of fieldsDisabled) {
                form.get(fieldName).disable();
            }
        }
    }

    disabledAllFields(form : FormGroup){
      this.disabledProperties = true;
      for (let field in form.controls) {
        form.get(field).disable();
      }
    }

    enabledAllFields(form : FormGroup){
      this.disabledProperties = false;
      for (let field in form.controls) {
        form.get(field).enable();
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/shared.component.ts